export default "__VITE_ASSET__B4el$3Ee__"